import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, ArrowUpRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Location = () => {
  const address = "Av. Brasil, 1128 - sala 2 - Centro, Santo Ângelo - RS, 98801-590";
  const googleMapsQuery = encodeURIComponent(address);
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${googleMapsQuery}`;

  return (
    <section className="py-16 bg-[#f8f9fa] border-t border-gray-100">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-3 gap-8 rounded-3xl overflow-hidden bg-white shadow-xl border border-gray-100">
          
          {/* Info Section */}
          <div className="p-8 lg:p-12 flex flex-col justify-center bg-white lg:col-span-1">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#0a4b3c]/10 text-[#0a4b3c] rounded-full font-medium text-sm mb-6 w-fit">
                <MapPin size={16} />
                <span>Onde Estamos</span>
              </div>
              
              <h2 className="text-2xl font-bold text-[#0a4b3c] mb-2">
                Contabilidade Assessoria TALC
              </h2>
              <p className="text-gray-500 mb-8">
                Visite nosso escritório no centro de Santo Ângelo
              </p>

              <div className="space-y-6 mb-8">
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Endereço</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Av. Brasil, 1128 - sala 2<br />
                    Centro, Santo Ângelo - RS<br />
                    CEP: 98801-590
                  </p>
                </div>
                
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">Horário de Atendimento</h3>
                  <p className="text-gray-600">
                    Segunda a Sexta: 08:00 - 12:00, 13:30 - 17:30
                  </p>
                </div>
              </div>

              <a 
                href={googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block w-full"
              >
                <Button className="w-full bg-[#0a4b3c] hover:bg-[#063127] text-white py-6 text-base group">
                  Venha nos visitar
                  <ArrowUpRight className="ml-2 w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </Button>
              </a>
            </motion.div>
          </div>

          {/* Map Section */}
          <div className="lg:col-span-2 min-h-[400px] bg-gray-100 relative">
             <iframe
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '400px' }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://maps.google.com/maps?q=${googleMapsQuery}&t=&z=16&ie=UTF8&iwloc=&output=embed`}
              title="Google Maps Location"
              className="absolute inset-0 w-full h-full"
            ></iframe>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Location;